import React from 'react';
import MainLayout from '../../layouts/MainLayout';
import { Card } from 'antd';
import WorkPageHeader from './WorkPageHeader';
import EntityBreadcrumb from '../common/EntityBreadcrumb';

/**
 * قالب یکدست صفحات افزودن/ویرایش ماژول کار
 */
const WorkFormPage = ({
  title,
  subtitle,
  icon,
  backPath,
  onBack,
  headerExtra,
  children,
  contentLoading = false,
  breadcrumbTrail = null,
  onBreadcrumbNavigate = null,
}) => (
  <MainLayout>
    <div style={{ fontFamily: 'CustomFont' }}>
      <Card className="shadow-xl border-0 work-page-card" bodyStyle={{ padding: 0 }}>
        {breadcrumbTrail?.length ? (
          <EntityBreadcrumb trail={breadcrumbTrail} onNavigate={onBreadcrumbNavigate} />
        ) : null}
        <WorkPageHeader
          title={title}
          subtitle={subtitle}
          icon={icon}
          showBack
          backPath={backPath}
          onBack={onBack}
          headerExtra={headerExtra}
        />
        <div
          className="p-6 work-page-body rounded-b-xl work-panel-form"
          style={{ fontFamily: 'CustomFont' }}
        >
          {contentLoading ? children : children}
        </div>
      </Card>
      <style>{`
        .work-panel-form .ant-form-item-explain-error,
        .work-panel-form .ant-form-item-explain,
        .work-panel-form .ant-form-item-label > label {
          font-family: CustomFont, sans-serif !important;
        }
        .work-panel-form .ant-form-item-has-error {
          margin-bottom: 28px !important;
        }
        .work-panel-form .ant-checkbox-wrapper,
        .work-panel-form .work-panel-checkbox,
        .work-panel-form .work-panel-checkbox span {
          font-family: CustomFont, sans-serif !important;
        }
      `}</style>
    </div>
  </MainLayout>
);

export default WorkFormPage;
